import CornYieldRisk from "./CornYieldRisk";

export default CornYieldRisk;